import React from "react";
import { DEFAULT_DEBOUNCE_TIMEOUT, DEFAULT_PAGE, DEFAULT_MINIMUM_FETCHED_OPTIONS } from "consts";
import { getGroupsPage } from "api";
//
import { AutoSuggest } from "containers/components/autoSuggest";

const GroupAutoSuggest = (props) => (
    <AutoSuggest
        label="Group"
        fetchOptions={(q) => props.onDataFetch(q)}
        renderOption={(group) => ({
            label: `${group.name}`,
            value: group
        })}
        optionIdentifier={(group) => group.id}
        debounceTimeout={DEFAULT_DEBOUNCE_TIMEOUT}
        {...props}
    />
);

GroupAutoSuggest.defaultProps = {
    onDataFetch: (q) =>
        getGroupsPage(q, DEFAULT_PAGE, DEFAULT_MINIMUM_FETCHED_OPTIONS, null, null, true)
            .then(value => value.content)
};

export default GroupAutoSuggest;
